import { render, staticRenderFns } from "./ProxyStatus.vue?vue&type=template&id=27cfab7a"
import script from "./ProxyStatus.vue?vue&type=script&lang=js"
export * from "./ProxyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports